import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';

export function reportGroup( report: any = {} ): FormGroup {
   return new FormGroup({
      id: new FormControl( report?.id ),
      name: new FormControl( report?.name ),
      shared: new FormControl( report?.shared ),

      version: new FormControl( '0.1' ),

      filters: new FormArray(( report?.filters ?? [] ).map( f => filterGroup( f )), [ Validators.minLength( 1 ) ]),
      schema: new FormArray(( report?.schema ?? [] ).map( s => schemaGroup( s )), [ Validators.minLength( 1 ) ]),
   });
}

export function filterGroup( filter: any = {} ): FormGroup {
   return new FormGroup({
      name: new FormControl( filter?.name, [ Validators.required ]),
      relative: new FormControl( filter?.relative ?? false ),
      value: new FormControl( filter?.value, [ Validators.required ]),
   });
}

export function schemaGroup( schema: any = {} ): FormGroup {
   return new FormGroup({
      name: new FormControl( schema?.name, [ Validators.required ]),
      header: new FormControl( schema?.header ),
      sort_ord: new FormControl( schema?.sort_ord ),
      sort_dir: new FormControl( schema?.sort_dir ?? 'desc' ),
   });
}
